var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1802 19.4801H7.82019V10.1201H17.1802V19.4801ZM9.64019 16.3601H15.3602V15.8401H9.64019V16.3601ZM9.64019 18.1801H15.3602V17.6601H9.64019V18.1801ZM14.4278 13.2401L12.5002 11.3125L10.5726 13.2401L12.5002 15.1678L14.4278 13.2401Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 12.0476L13.6922 13.24L12.4999 14.4323L11.3075 13.24L12.4999 12.0476Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5356 20C14.4284 20.3029 14.1396 20.52 13.8 20.52H11.1995C10.9928 20.52 10.7944 20.4378 10.6483 20.2917C10.5654 20.2085 10.503 20.1087 10.4645 20H14.5356Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9602 20V21.56H7.04016V20H9.92642C9.97686 20.248 10.0991 20.4779 10.2808 20.6594C10.5244 20.903 10.8549 21.04 11.1996 21.04H13.8002C14.4291 21.04 14.9538 20.5933 15.0742 20H17.9602Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.48 20.26H19V21.3H18.48V20.26Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20.26H6.52V21.3H6V20.26Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9602 8.04004V9.60004H15.0742C14.9538 9.00672 14.4291 8.56004 13.8002 8.56004H11.1996C10.8549 8.56004 10.5244 8.69706 10.2808 8.94068C10.0991 9.12216 9.97686 9.352 9.92642 9.60004H7.04016V8.04004H17.9602Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5356 9.60008H10.4645C10.503 9.4914 10.5654 9.39156 10.6483 9.30836C10.7944 9.16224 10.9928 9.08008 11.1995 9.08008H13.8C14.1396 9.08008 14.4284 9.29718 14.5356 9.60008Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.30005H6.52V9.34005H6V8.30005Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.48 8.30005H19V9.34005H18.48V8.30005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuest);
export default __webpack_public_path__ + "static/media/quest.a4647f766f1559091ee94db97437d8d2.svg";
export { ForwardRef as ReactComponent };